import _ from 'lodash';
import config from './default';

const prod = _.cloneDeep(config);

prod.api = {
  ez_pay: {
    hostInstances: 'https://api.ez-pay.co/ez-pay/v1',
  },
  rcp: {
    hostInstances: 'https://api.kubra.io/rcp/v1',
  }
};



prod.googleAnalyticsCode = 'G-VJRHN9SM1R';

prod.awsWafUrl = "https://4d640c2bc052.edge.sdk.awswaf.com/4d640c2bc052/f5d69bf3046e/challenge.js";

prod.luckyOrangeUrl = 'https://tools.luckyorange.com/core/lo.js?site-id=2afb25b9';

export default prod;
